import { Navigate } from "react-router-dom";
import { Shield } from "lucide-react";
import { useCanManageCompany } from "@/hooks/useCanManageCompany";

/** Guard for Settings › Company pages. Same check as the settings sidebar. */
export default function CompanyAdminRoute({ children }: { children: React.ReactNode }) {
  const { allowed, isLoading, error, refetch } = useCanManageCompany();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (error && !allowed) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-6">
        <div className="max-w-sm w-full bg-card border border-border rounded-xl p-6 text-center space-y-3">
          <Shield className="w-6 h-6 text-muted-foreground mx-auto" />
          <p className="text-foreground font-medium">Couldn't verify access</p>
          <p className="text-sm text-muted-foreground">
            We couldn't reach the server to confirm your permissions. Please try again.
          </p>
          <button
            onClick={refetch}
            className="inline-flex items-center justify-center rounded-md bg-primary text-primary-foreground px-4 py-2 text-sm font-medium hover:opacity-90 transition-opacity"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!allowed) return <Navigate to="/" replace />;
  return <>{children}</>;
}
